import * as startrack from "./startrack";
import * as tge from "./tge";
import * as tnt from "./tnt";

export const { STARTRACK } = startrack;
export const { TGE } = tge;
export const { TNT } = tnt;

const define = (module, id) => ({
  id,
  label: id,
  badgeClass: module.badgeClass,
  detect: module.detect,
  parse: module.parse,
});

const STARTRACK_CARRIER = define(startrack, STARTRACK);
const TGE_CARRIER = define(tge, TGE);
const TNT_CARRIER = define(tnt, TNT);

export const CARRIERS = [STARTRACK_CARRIER, TGE_CARRIER, TNT_CARRIER];

export const DETECTION_ORDER = [TGE_CARRIER, TNT_CARRIER, STARTRACK_CARRIER];

export function findCarrier(id) {
  return CARRIERS.find((carrier) => carrier.id === id) || null;
}
